import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4 sm:px-6 bg-brand-bg" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-brand-accent/30 rounded-2xl p-8 md:p-10 text-center shadow-lg relative overflow-hidden" data-id="element-18">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-accent/10 rounded-bl-full -z-10" data-id="element-19"></div>

          <div className="inline-flex items-center justify-center p-4 bg-brand-accent/10 rounded-full mb-6 text-brand-accent" data-id="element-20">
            <ShieldCheckIcon size={48} data-id="element-21" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-brand-text mb-4" data-id="element-22">
            Garantía de 7 Días
          </h2>

          <p className="text-lg text-brand-text/80 leading-relaxed" data-id="element-23">
            Prueba el Método 2-2-2 este domingo. Si no logras preparar tus
            módulos en 2 horas, o si tus cenas de la semana no están listas en 5
            minutos, envíame un correo y te devolveré el 100% de tu dinero. Sin
            preguntas, sin resentimientos.
          </p>
        </motion.div>
      </div>
    </section>;
}